<template>
  <div class="inner-container">

    <div style = " width: 100vw;z-index:99" class="toolbar-header">
  
            <p @click="$router.push({name: 'landing'})" class="mar-text" style="font-family: 'DINPro Bold'">Mar of <br/> Santa Barbara</p>
            <p v-if="$store.state.currentFilter != 'Catagories'" style="font-family: 'DINPro Regular; text-align: center;'">{{ $store.state.currentFilter }}</p>
            <p v-else style="font-family: 'DINPro Regular; text-align: center;'">Collections</p>
            <p></p>
    
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  created() {},
  data() {
    return {
       drawer: false,
       mini: false
    };
  },
  computed: {
  },
  methods: {
    routeTo(route) {
        this.drawer = false
        this.$router.push({name: route})
    }
  }
};
</script>

<style scoped>
.nav-tile {
    -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.inner-container {
    background-color: white;
    min-height: 100vh;
}
#drawerButton {
    position: fixed;
}
.nav-tile:hover {
    cursor: pointer;
    box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
  -webkit-box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
  -moz-box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
}
.toolbar-header {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  background: #212121;
  height: 4rem;
  position: fixed;
  padding-left: 1rem;
  padding-right: 1rem;
}
.toolbar-header p {
  color: white;
  margin: 0 !important;
  width: 100%;
}
.mar-text:hover {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// CollectionContainer.vue?729c49c2